import React from "react";
const StyledWraper: React.FC<{
  children: React.ReactNode;
  className?: string;
  behindClassName?: string;
}> = ({ children, className, behindClassName }) => {
  return (
    <div className={`relative rounded-none ${className}`}>
      <div
        className={`absolute z-[-4] -bottom-[2px] max-w-full w-[calc(100%-2px)] bg-themeColor rounded-xl left-1/2 -translate-x-1/2  max-h-full  h-full ${behindClassName}`}
      ></div>
      <div className={`overflow-clip h-full ${behindClassName}`}>
        {children}
      </div>
    </div>
  );
};
export default StyledWraper;
